/**
 * The trainer's question shelf, as `queryOptions`.
 *
 * Moved out of `pages/reports/api/reportsQueries` on 27 September 2026 with the editor it serves.
 * The keys are UNCHANGED and still sit under `['reports']`: the Raporty editor's save invalidates
 * that whole prefix, and the shelf answering to the same blanket is part of the behaviour the move
 * had to keep.
 */

import { queryOptions } from '@tanstack/react-query';

import { getSurveyQuestionCatalog } from '~/shared/api/generated/endpoints/survey/survey';

import { surveyTemplatesCacheRoot } from './catalogQueries';

/**
 * The shelf's prefix — the one key a shelf write invalidates.
 *
 * A prefix rather than the key itself, so the editor's bookmark, the catalog screen's pencil and its
 * trash all say the same thing in one line and none of them has to know the shape below it.
 */
export const questionCatalogRoot = [...surveyTemplatesCacheRoot, 'questionCatalog'] as const;

export const questionCatalogQueryKey = [...questionCatalogRoot] as const;

/**
 * `GET /survey/question-catalog` — the trainer's own saved questions, with `usedIn` on each (R35).
 *
 * `staleTime: 0`, unlike the forms beside it: this is a shelf the trainer adds to from the EDITOR,
 * on another route, and a five minute window would show them a catalog missing the question they
 * had just bookmarked. It takes no parameters — the filters on `/raporty/katalog` narrow the one
 * response rather than asking again.
 */
export function questionCatalogQueryOptions() {
  return queryOptions({
    queryKey: questionCatalogQueryKey,
    queryFn: ({ signal }) => getSurveyQuestionCatalog(undefined, signal),
    staleTime: 0,
  });
}
